/**
 * User zod schemas — REQ-20260418006。
 * 管理員維護使用者；passwordHash / deletedAt 絕不外露。
 */
import { z } from 'zod';
import { Role } from '../enums/role';

export const UserResponseSchema = z.object({
  id: z.number().int().positive(),
  uuid: z.string().uuid(),
  username: z.string(),
  displayName: z.string(),
  email: z.string(),
  role: z.nativeEnum(Role),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type UserResponse = z.infer<typeof UserResponseSchema>;

export const CreateUserSchema = z.object({
  username: z
    .string()
    .trim()
    .min(1, 'username 必填')
    .max(50)
    .regex(/^[a-zA-Z0-9._-]+$/, 'username 只能含英數 . _ -'),
  displayName: z.string().trim().min(1).max(50),
  email: z.string().trim().email().max(320),
  password: z.string().min(8, '密碼至少 8 字元').max(200),
  role: z.nativeEnum(Role).default(Role.SALES),
  isActive: z.boolean().default(true),
});
export type CreateUserInput = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = z.object({
  displayName: z.string().trim().min(1).max(50).optional(),
  email: z.string().trim().email().max(320).optional(),
  password: z
    .string()
    .min(8, '密碼至少 8 字元')
    .max(200)
    .optional()
    .or(z.literal('').transform(() => undefined)),
  role: z.nativeEnum(Role).optional(),
  isActive: z.boolean().optional(),
});
export type UpdateUserInput = z.infer<typeof UpdateUserSchema>;

export const UserListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(25),
  q: z.string().trim().max(100).optional(),
  role: z.nativeEnum(Role).optional(),
  isActive: z.coerce.boolean().optional(),
  sort: z.string().optional().default('createdAt'),
  order: z.enum(['asc', 'desc']).default('desc'),
});
export type UserListQuery = z.infer<typeof UserListQuerySchema>;
